import React, {memo} from "react"
import {Form} from "antd"
import {CustomInput} from "../../../components/Custom/Input"
import FIOInput from "../../../components/FormItems/FIOInput";
import {useTranslation} from "react-i18next";
import IssueDocInput from "../../../components/FormItems/IssueDocInput";

const Citizen = memo((props: any) => {
	const { form, isNotToChange } = props
	const {t} = useTranslation(['resources', 'translation'])
	const user = props.user ? props.user : {}

	return (
		<>
			<FIOInput/>
			<Form.Item
				hasFeedback
				label={t('DocTypeNameIdentical')}
				name="numberDocRB"
				normalize={(value) => (value ? value.trim() : value)}
				rules={[
					{
						required : true,
						message : t('validation:RequiredField')
					},
					{
						pattern  : /^(?=^.{14}$)[0-9]{7}[A-Z][0-9]{3}[A-Z]{2}[0-9]$/,
						message  : t('validation:ValidateIdentityNumber')
					}
				]}
			>
				<CustomInput
					autoComplete="off"
					maxLength={50}
					placeholder="1234567A123PB1"
				/>
			</Form.Item>
			<Form.Item
				hasFeedback
				dependencies={["numberDocRB"]}
				label={t('DoctypeNameConfirmIdentical')}
				name="confirmNumberDocRB"
				normalize={(value) => (value ? value.trim() : value)}
				rules={[
					{
						required : true,
						message : t('validation:RequiredField')
					},
					({ getFieldValue }) => ({
						validator(_, value){
							if (!value || getFieldValue("numberDocRB") === value)
								return Promise.resolve()
							return Promise.reject(t('validation:AppUserModelValidateDifferentNumberDoc'))
						}
					})
				]}
			>
				<CustomInput
					autoComplete="off"
					maxLength={50}
					placeholder="1234567A123PB1"
				/>
			</Form.Item>
			<Form.Item
				hasFeedback
				label={t('AppUserModelNumberDoc2')}
				name="passportNumber"
				normalize={(value) => (value ? value.trim() : value)}
				rules={[
					{
						required : true,
						message : t('validation:RequiredField')
					},
					{
						pattern  : /^[A-Z]{2}[0-9]{7}$/,
						message  : t('validation:AppUserModelNumberDoc2ErrorMessage')
					}
				]}
			>
				<CustomInput
					autoComplete="off"
					maxLength={50}
					placeholder="AB1234567"
				/>
			</Form.Item>
			<IssueDocInput />
		</>
	)
})

export default Citizen
